import apiCall from "./apiCall";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
 

  async fetchInvoices(page) {
    let data = {
      page: page
    };
    let response = await apiCall("invoice/list", data);
    return response;
  },

  async searchAllInvoices(page, from, to, search) {
    let data = {
      page: page,
      from: from,
      to: to,
      search: search
    };
    let response = await apiCall("invoice/list", data);
    return response;
  },

  async fetchMMTransactions(page) {
    let data = {
      page: page
    };
    let response = await apiCall("mm/report", data);
    return response;
  },

  async fetchPMTransactions(page) {
    let data = {
      page: page
    };
    let response = await apiCall("pocket_money/list", data);
    return response;
  },

  async searchMMTransactions(page, from, to, search, type, status) {
    let data = {
      page: page,
      from: from,
      to: to,
      search: search,
      account_id: type,
      status:status
    };
    let response = await apiCall("mm/report", data);
    return response;
  },

  async searchPMTransactions(page, from, to, search, account_id) {
    let data = {
      page: page,
      from: from,
      to: to,
      search: search,
      account_id: account_id
    };
    let response = await apiCall("pocket_money/list", data);
    return response;
  },

  async fetchBuzztimeTransactions(page) {
    let data = {
      page: page,
      account_id: "1"
    };
    let response = await apiCall("wallet/list", data);
    return response;
  },

  async searchBuzztimeTransactions(search, from, to, page) {
    let data = {
      search: search,
      from: from,
      to: to,
      page: page,
      account_id: "1"
    };
    let response = await apiCall("wallet/list", data);
    return response;
  },

  async fetchAdminRefundTransactions(page) {
    let data = {
      page: page,
      account_id: "8"
    };
    let response = await apiCall("wallet/list", data);
    return response;
  },

  async searchAdminRefundTransactions(search, from, to, page) {
    let data = {
      search: search,
      from: from,
      to: to,
      page: page,
      account_id: "8"
    };
    let response = await apiCall("wallet/list", data);
    return response;
  },

  async fetchCallTransactions(page) {
    let data = {
      page: page,
      account_id: "3"
    };
    let response = await apiCall("wallet/list/mod", data);
    return response;
  },

  async searchCallTransactions(search, from, to, page) {
    let data = {
      search: search,
      from: from,
      to: to,
      page: page,
      account_id: "3"
    };
    let response = await apiCall("wallet/list/mod", data);
    return response;
  },

  async fetchMessageTransactions(page) {
    let data = {
      page: page,
      account_id: "2"
    };
    let response = await apiCall("wallet/list/mod", data);
    return response;
  },

  async searchMessageTransactions(search, from, to, page) {
    let data = {
      search: search,
      from: from,
      to: to,
      page: page,
      account_id: "2"
    };
    let response = await apiCall("wallet/list/mod", data);
    return response;
  },
  
  async fetchRecentMMTransactions(data) {
    let response = await apiCall("bank/mm/recent", data);
    return response;
  },
  async fetchBuzzTimeUsed(data) {
    let response = await apiCall("buzz_time/used/today", data);
    return response;
  },
  async fetchBuzzTimeLoaded(data) {
    let response = await apiCall("buzz_time/loaded/today", data);
    return response;
  },
  async fetchUserWalletTransactions(page, user) {
    let data = {
      page: page,
      user_id: user,
      
    };
    let response = await apiCall("wallet/list/mod", data);
    return response;
  },
  async fetchBuzzTimeTotal(data) {
    let response = await apiCall("buzz_time/total", data);
    return response;
  },
  async fetchPocketMoneyTotal(data) {
    let response = await apiCall("pocket_money/total", data);
    return response;
  },
  async fetchAccountActivationsTotal(data) {
    let response = await apiCall("account_activation/total", data);
    return response;
  },
  async fetchTotalCallCharges(data) {
    let response = await apiCall("call_charges/total", data);
    return response;
  },
  async fetchTotalMessageCharges(data) {
    let response = await apiCall("message_charges/total", data);
    return response;
  },
  async generateMessageReport(data) {
    let response = await apiCall("message/report", data);
    return response;
  },
  async fetchStudentWalletBalance(student) {
    let data = {
      user_id: student
    };
    let response = await apiCall("wallet/balance", data);
    return response;
  },
  async fetchActivationFee(type, student_id) {
    let data = {
      type: type,
      student_id: student_id
    };
    let response = await apiCall("school_rate/activation/get", data);
    return response;
  },
  async fetchRenewalFee(type, student_id) {
    let data = {
      type: type,
      student_id: student_id
    };
    let response = await apiCall("school_rate/replacement/get", data);
    return response;
  },
  async fetchAccountActivationInvoices(page) {
    let data = {
      page: page
    };
    let response = await apiCall("mobile/webapp/activation_invoices/list", data);
    return response;
  },
  async searchAccountActivationInvoices(searchTerm, startDate, endDate, page) {
    let data = {
      search: searchTerm,
      from: startDate,
      to: endDate,
      page: page
    };
    let response = await apiCall("mobile/webapp/activation_invoices/list", data);
    return response;
  },
  async initiateAdminRefund(secure_string, student_user_id, amount, description) {
    let data = {
      secure_string: secure_string,
      student_user_id: student_user_id,
      amount: amount,
      description: description
    };
    let response = await apiCall("mobile/webapp/admin_refund", data);
    return response;
  },
  async fetchBuzzTimeUsedEachMonth(data) {
    let response = await apiCall("buzztime/each_month/report", data);
    return response;
  },
  async fetchAccountActivationsEachMonth(data) {
    let response = await apiCall("account_activations/each_month/report", data);
    return response;
  },
  async fetchPocketMoneyBalance(user) {
    let data = {
      user_id: user
    };
    let response = await apiCall("pocket_money/balance", data);
    return response;
  },
  async fetchUserPocketMoneyTransactions(page, user) {
    let data = {
      page:page,
      user_id: user
    };
    let response = await apiCall("pocket_money/list/user", data);
    return response;
  },

  async searchUserPocketMoneyTransactions(page, user, startDate, endDate, account_id) {
    let data = {
      page:page,
      user_id: user,
      from: startDate,
      to: endDate,
      account_id: account_id
    };
    let response = await apiCall("pocket_money/list/user", data);
    return response;
  },

  async fetchUserPocketMoneyTransactionsReport(page, user, startDate, endDate) {
    let data = {
      page:page,
      user_id: user,
      from: startDate,
      to: endDate
    };
    let response = await apiCall("pocket_money/list/user", data);
    return response;
  },

  async fetchRecentPocketMoneyTransactions(data) {
    let response = await apiCall("bank/pocket_money/recent", data);
    return response;
  },
  async fetchStudentCreditBalance() {
    let data = {
      role_id: 5
    };
    let response = await apiCall("bank/credit_balance/total", data);
    return response;
  },
  async fetchParentCreditBalance() {
    let data = {
      role_id: 4
    };
    let response = await apiCall("bank/credit_balance/total", data);
    return response;
  },
  async fetchOverallPocketMoneyBalance(data) {
    let response = await apiCall("bank/pocket_money_balance/total", data);
    return response;
  },
  async fetchAllSchoolCreditBalances(data) {
    let response = await apiCall("bank/credit_balance/school/all", data);
    return response;
  },
  async fetchSchoolCreditBalance(school_id) {
    let data = {
      school_id: school_id
    };
    let response = await apiCall("bank/credit_balance/school/total", data);
    return response;
  },
  async fetchSchoolPocketMoneyBalance(school_id) {
    let data = {
      school_id: school_id
    };
    let response = await apiCall("bank/pocket_money_balance/school/total", data);
    return response;
  },
  async fetchAllSchoolPocketMoneyBalances(data) {
    let response = await apiCall("bank/pocket_money_balance/school/all", data);
    return response;
  },
  async fetchPMConversions(page) {
    let data = {
      page: page,
      account_id: "5"
    };
    let response = await apiCall("pocket_money/list", data);
    return response;
  },

  async searchPMConversions(search, from, to, page) {
    let data = {
      search: search,
      from: from,
      to: to,
      page: page,
      account_id: "5"
    };
    let response = await apiCall("pocket_money/list", data);
    return response;
  },
  async fetchMMChargesToday(data) {
    let response = await apiCall("mm_charges/today", data);
    return response;
  },
  async searchMMCharges(from, to) {
    let data = {
      from: from,
      to: to
    };
    let response = await apiCall("mm_charges/total", data);
    return response;
  },
  async fetchMMChargesTotal(data) {
    let response = await apiCall("mm_charges/total", data);
    return response;
  },
  async fetchWithdrawChargeBalance(data) {
    let response = await apiCall("mm/withdraw_charge/balance", data);
    return response;
  },
  async searchMMChargesList(page, from, to) {
    let data = {
      page: page,
      from: from,
      to: to
    };
    let response = await apiCall("mobile/webapp/withdraw_charge_transactions", data);
    return response;
  },
  async fetchMMChargesList(page) {
    let data = {
      page: page
    };
    let response = await apiCall("mobile/webapp/withdraw_charge_transactions", data);
    return response;
  },

  async searchTotalDepositChargesForSchools(from, to) {
    let data = {
      from: from,
      to: to
    };
    let response = await apiCall("mm/deposit_charges/total/schools", data);
    return response;
  },
  async fetchTotalDepositChargesForSchools(data) {
    let response = await apiCall("mm/deposit_charges/total/schools", data);
    return response;
  },

  async searchTotalWithdrawChargesForVendors(from, to) {
    let data = {
      from: from,
      to: to
    };
    let response = await apiCall("mm/withdraw_charges/total/vendors", data);
    return response;
  },
  async fetchTotalWithdrawChargesForVendors(data) {
    let response = await apiCall("mm/withdraw_charges/total/vendors", data);
    return response;
  },
  async fetchMMCollectionsCategorized(data) {
    let response = await apiCall("bank/mm_collections/each_month", data);
    return response;
  },
  async fetchMMCollectionsToday(data) {
    let response = await apiCall("bank/mm_collections/today", data);
    return response;
  },
  async fetchPMTransactionsCategorized(data) {
    let response = await apiCall("bank/pm_collections/each_month", data);
    return response;
  },
  async fetchPMTransactionsToday(data) {
    let response = await apiCall("bank/pm_collections/today", data);
    return response;
  },
  async fetchOverallFloatVendorBalance(data) {
    let response = await apiCall("bank/vendor_float_balance/total", data);
    return response;
  },
  async fetchRecentVendorDisbursements(data) {
    let response = await apiCall("bank/vendor_disbursements/recent", data);
    return response;
  },
  async fetchUserPocketMoneyTransactionsPrintable(user) {
    let data = {
      user_id: user
      
    };
    let response = await apiCall("mobile/webapp/pocket_money_wallet/user/printable", data);
    return response;
  },
   async fetchFilteredPocketMoneyTransactionsPrintable(user, from, to) {
    let data = {
      user_id: user,
      from: from,
      to: to
    };
    let response = await apiCall("mobile/webapp/pocket_money_wallet/user/printable", data);
    return response;
  },
  async fetchSchoolDashboardVendors(school_id) {
    let data = {
      school_id: school_id
    };
    let response = await apiCall("vendor/school_list/transaction_status_today", data);
    return response;
  },
  async cancelMMTransaction(trans) {
    let data = {
      trans: trans
    };
    let response = await apiCall("mm/status/cancel", data);
    return response;
  },
  async fetchDirectMessageTransactions(page) {
    let data = {
      page: page,
      account_id: "5"
    };
    let response = await apiCall("wallet/list/mod", data);
    return response;
  },
  async searchDirectMessageTransactions(search, from, to, page) {
    let data = {
      search: search,
      from: from,
      to: to,
      page: page,
      account_id: "5"
    };
    let response = await apiCall("wallet/list/mod", data);
    return response;
  },
  async fetchPocketMoneyHighlights(data) {
    let response = await apiCall("bank/pocket_money/highlights", data);
    return response;
  },
  async fetchTermlyFeeInvoices(page) {
    let data = {
      page: page
    };
    let response = await apiCall("mobile/webapp/termly_fee_invoices/list", data);
    return response;
  },
  async searchTermlyFeeInvoices(page, search, from, to, term_id, school_id) {
    let data = {
      search: search,
      from: from,
      to: to,
      page: page,
      term_id: term_id,
      school_id: school_id
    };
    let response = await apiCall("mobile/webapp/termly_fee_invoices/list", data);
    return response;
  },

  async fetchCommissions(page) {
    let data = {
      page: page
    };
    let response = await apiCall("mobile/webapp/list_all_commissions", data);
    return response;
  },

  async searchCommissions(page, from, to, search) {
    let data = {
      page: page,
      from: from,
      to: to,
      search: search
    };
    let response = await apiCall("mobile/webapp/list_all_commissions", data);
    return response;
  },
  async fetchTotalTermlyFeesPaid(data) {
    let response = await apiCall("bank/termly_fees/total", data);
    return response;
  },
  async fetchTermlyFeeInvoiceCount(data) {
    let response = await apiCall("bank/termly_fees/invoice/count", data);
    return response;
  },
  async fetchTermlyFeeStatsPerSchool(data) {
    let response = await apiCall("mobile/webapp/termly_fee_stats_per_school", data);
    return response;
  },
  async searchTermlyFeeStatsPerSchool(startDate, endDate) {
    let data = {
      from: startDate,
      to: endDate
    };
    let response = await apiCall("mobile/webapp/termly_fee_stats_per_school", data);
    return response;
  },
  async fetchOverallVendorCommissionBalance(data) {
    let response = await apiCall("bank/commission_balance/total", data);
    return response;
  },
  async fetchTotalPOSDepositCharges(data) {
    let response = await apiCall("bank/pos_deposit_charges/total", data);
    return response;
  },
  async searchTotalPOSDepositChargesForVendors(from, to) {
    let data = {
      from: from,
      to: to
    };
    let response = await apiCall("bank/pos_deposit_charges/total/vendors", data);
    return response;
  },
  async fetchTotalPOSDepositChargesForVendors(data) {
    let response = await apiCall("bank/pos_deposit_charges/total/vendors", data);
    return response;
  },
  async searchPOSDepositChargesList(page, from, to, vendor) {
    let data = {
      page: page,
      from: from,
      to: to,
      user_id: vendor
    };
    let response = await apiCall("mobile/webapp/list_all_pos_deposit_charges", data);
    return response;
  },
  async fetchPOSDepositChargesList(page) {
    let data = {
      page: page
    };
    let response = await apiCall("mobile/webapp/list_all_pos_deposit_charges", data);
    return response;
  },
  async fetchTermlyFeeStatsToday(data) {
    let response = await apiCall("mobile/webapp/termly_fee_stats_today", data);
    return response;
  },
  async printMMTransactions(from, to, search, type, status) {
    let data = {
      from: from,
      to: to,
      search: search,
      account_id: type,
      status:status
    };
    let response = await apiCall("mm/report/printable", data);
    return response;
  },



}